import { Dialog, useMediaQuery, useTheme } from "@material-ui/core"
import BottomDrawer from "components/Common/BottomDrawer"
import PropTypes from "prop-types"

const ConditionalDialogWrapper = ({
  open = false,
  onClose,
  children,
  className = "",
  newClasses,
  drawerColor,
}) => {
  // in implementation, takes from a dialog both the open and the show prop
  // open prop only present if !mobileView, while show prop exists only if mobileView
  // open -> dialog state, while show -> drawer state
  const theme = useTheme()
  const mobileView = useMediaQuery(theme.breakpoints.down("xs"))

  if (mobileView) {
    return (
      <BottomDrawer
        show={open}
        componentToRender={children}
        onClose={onClose}
        drawerColor={drawerColor}
      />
    )
  } else {
    return (
      <Dialog
        open={open}
        className={className}
        classes={newClasses}
        scroll="paper"
      >
        {children}
      </Dialog>
    )
  }
}

ConditionalDialogWrapper.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  newClasses: PropTypes.any,
  drawerColor: PropTypes.string,
}

export default ConditionalDialogWrapper
